const env = require(`./config.${process.env.REACT_APP_ENV || "dev"}.json`);

const config = {
  // App Details
  appName: "Simulator",

  version: "0.1",
  baseURL: env.serverUrl,

  sms: {
    sender: "Spetz",
    url: "http://simplesms.co.il/WebService/sendsmsws.asmx/SendSms",
    username: "ofir2144",
    encryptedPassword: "d7722c15e07443418edf8da5ab520491",
  },
  countryCode: "44",
  stripe: env.stripe,
  google: {
    tagManager: {
      gtmId: env.gtmId,
    },
  },
  phoneNumberLength: {
    IL: {
      withPrefix: 12,
      withoutPrefix: 9,
    },
    GB: {
      withPrefix: 12,
      withoutPrefix: 10,
    },
    AU: {
      withPrefix: 11,
      withoutPrefix: 9,
    },
    US: {
      withPrefix: 11,
      withoutPrefix: 10,
    },
  },
  datadog: {
    clientToken: "pub70be6831cbadbf5dd8feabd31fd64511",
    site: "datadoghq.eu",
    env: process.env.REACT_APP_ENV || "development",
    service: "Simulator",
    sampleRate: 100,
    forwardConsoleLogs: [],
    forwardErrorsToLogs: true,
    logLevel: "debug",
  },
  // officeGuy: {
  //     REACT_APP_OFFICEGUY_API_KEY: env.REACT_APP_OFFICEGUY_API_KEY,
  //     REACT_APP_OFFICEGUY_COMPANY_ID: env.REACT_APP_OFFICEGUY_COMPANY_ID,
  // }
};

export default config;

export const getStripeKey = (country) => {
  return env.stripe[country];
};

export const setCountryCode = (country) => {
  config.countryCode = country === "IL" ? "972" : "44";
  config.countryName = country;
};
